import { create } from 'zustand';
import dayjs from 'dayjs';
import { get_renovation_nexttendays, get_renovation_month } from '../utils/apis/home';

export const useRenovationStore = create((set, get) => ({
  items: [],
  filteredItems: [],
  loading: false,
  error: null,
  
  // Stats
  totalAccounts: 0,
  revenueAtRisk: 0,
  criticalAccounts: 0, // Today or expired

  getRenovations: async (type = '10-days') => {
    set({ loading: true, error: null });
    try {
      let data = [];
      if (type === '10-days') {
        const res = await get_renovation_nexttendays();
        const tenDaysLimit = dayjs().add(10, 'day').endOf('day');
        // Filter logic from Home.jsx
        data = res.filter(item => dayjs(item.limit_date_billing).isBefore(tenDaysLimit));
      } else {
        data = await get_renovation_month();
      }

      const totalRevenue = data.reduce((acc, curr) => acc + (parseFloat(curr.price_type_plan) || 0), 0);
      const critical = data.filter(item => dayjs(item.limit_date_billing).isBefore(dayjs().endOf('day'))).length;

      set({ 
        items: data, 
        filteredItems: data,
        totalAccounts: data.length,
        revenueAtRisk: totalRevenue,
        criticalAccounts: critical,
        loading: false 
      });
    } catch (error) {
      console.error('Error in renovation store:', error);
      set({ error: 'Error al cargar renovaciones', loading: false });
    }
  },

  searchRenovations: (query) => {
    const { items } = get();
    if (!query) {
      set({ filteredItems: items });
      return;
    }

    const filters = query.toUpperCase().split(' ');
    const filtered = items.filter(item => {
      const itemData = `${item.full_name?.toUpperCase() || ''} ${item.num_account?.toUpperCase() || ''}`;
      return filters.every(f => itemData.includes(f));
    });

    set({ filteredItems: filtered });
  },

  clearSearch: () => {
    const { items } = get();
    set({ filteredItems: items });
  }
}));
